/**
 * Created by Mikhail Menshenin on 15.08.2024
 */

class VillageAttackSceneComponent extends VillageSceneComponent {
    onCreate() {
        super.onCreate();

        if (!this.args.snapshotLoaded) {
            this.village.prepareToAttack();
        }
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        this.village.counter.registerStage(10, () => {
            if (this.village.isAttacked() || this.village.defended()) {
                this.showResultPanel();
            }
        });

        cleverapps.focusManager.showControlsTemporary("village");

        this.village.on("assault", this.hideHammer.bind(this), this.node);
        this.village.on("defense", this.hideHammer.bind(this), this.node);

        if (!this.village.isStateAttack()) {
            this.village.counter.trigger();
            this.controlPanel.hide();
        }
    }

    addUI() {
        const styles = cleverapps.styles.VillageAttackScene;

        const controlPanel = this.controlPanel = new VillageAttackControlView(this.village);
        controlPanel.setAlignment(styles.control);
        if (cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL) {
            cleverapps.UI.fitToBox(controlPanel, styles.control);
        }
        this.node.addChild(controlPanel);
        controlPanel.show();

        if (this.village.isStateAttack()) {
            const hammer = this.attackHammer = new cleverapps.Spine(bundles.transition_attack.jsons.attack_transition_json);
            hammer.setAlignment({ align: "center" }, hammer.height * 0.4);
            hammer.setAnimationAndIdleAfter("close", "glow");
            this.node.addChild(hammer);
        }
    }

    hideHammer() {
        if (!this.attackHammer) {
            return;
        }

        this.attackHammer.runAction(new cc.Sequence(
            new cc.DelayTime(0.8),
            new cc.MoveBy(0.2, 0, -this.attackHammer.height * 1.5).easing(cc.easeIn(1)),
            new cc.Hide()
        ));
    }

    showResultPanel() {
        const styles = cleverapps.styles.VillageAttackScene;

        const resultPanel = this.resultPanel = new VillageAttackResultView(this.village);
        resultPanel.setAlignment(styles.result.position);
        resultPanel.setScale2(styles.result.scale);
        this.node.addChild(resultPanel);
        resultPanel.show();

        const label = this.tapToContinue = new TapToContinue({
            text: "Window.TapToContinue"
        });
        label.setAlignment(styles.tapToContinue);
        this.node.addChild(label);
        label.show();

        cleverapps.UI.onClick(this.node, this.hideResultPanel.bind(this), {
            interactiveScale: false
        });
    }

    hideResultPanel() {
        this.resultPanel.runAction(new cc.Sequence(
            new cc.DelayTime(0.1),
            new cc.CallFunc(() => {
                this.tapToContinue.hide();
            }),
            new cc.MoveBy(0.4, 0, -this.resultPanel.height).easing(cc.easeOut(3)),
            new cc.CallFunc(this.finish.bind(this))
        ));
    }

    listBundles() {
        return super.listBundles().concat(["transition_attack"]);
    }
}

Prefab.registerComponent("VillageAttackSceneComponent", VillageAttackSceneComponent);

cleverapps.styles.VillageAttackScene = {
    control: {
        width: 520,
        height: 160,
        x: { align: "center", dx: 3 },
        y: { align: "top", dy: 35 }
    },

    result: {
        scale: [0.6, 1, 1],
        position: [{
            x: { align: "center" },
            y: { align: "bottom", dy: -20 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: -40 }
        }, {
            x: { align: "center" },
            y: { align: "bottom", dy: -40 }
        }]
    },

    tapToContinue: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: 250 }
    }
};

MenuControlButton.isAvailableOnScene = cleverapps.extendFunc(MenuControlButton.isAvailableOnScene, function () {
    if (cleverapps.environment.hasScene([cleverapps.Environment.SCENE_VILLAGE_ATTACK, cleverapps.Environment.SCENE_VILLAGE_RAID])) {
        return false;
    }

    return this._super();
});
